import { DetailsItem } from "../Details";
import ExpirableDate from "../ExpirableDate";
import AssetConnectivityIssuesNotification from "./AssetConnectivityIssuesNotification";
import { Timeouts } from "../../constants";

type Props = {
  asset: {
    last_seen_at?: string;
  };
};

function AssetLastSeen({ asset }: Props) {
  return (
    <DetailsItem id="asset-last-seen" translationKey="label.last_seen">
      {asset.last_seen_at ? (
        <ExpirableDate
          id="asset-last-seen-date"
          date={new Date(asset.last_seen_at)}
          hoursAfterLatestUpdateToExpire={Timeouts.ASSET_OFFLINE_WARNING_HOURS}
          infoPopup={
            <AssetConnectivityIssuesNotification
              type="last-seen"
              // @ts-expect-error TS(2322) FIXME: Type '{ type: string; lastConnectionDate: string; ... Remove this comment to see the full error message
              lastConnectionDate={asset.last_seen_at}
              hoursAfterLatestUpdateToExpire={
                Timeouts.ASSET_OFFLINE_WARNING_HOURS
              }
            />
          }
        />
      ) : null}
    </DetailsItem>
  );
}

export default AssetLastSeen;
